import React from 'react';

import { ConfirmDialog as Dialog, Typography } from '@gogame/components';

const ConfirmDialog = (props) => {
  return (
    <Dialog {...props}>
      <Typography>Are you sure want to delete subscription?</Typography>
    </Dialog>
  );
};

export default ConfirmDialog;
